var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWlFavicon192X192(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 192,
    height: 192,
    viewBox: "0 0 192 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_209_8601)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_209_8601",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M192 96C192 149.019 149.019 192 96 192C42.9807 192 0 149.019 0 96C0 42.9807 42.9807 0 96 0C149.019 0 192 42.9807 192 96Z",
    fill: "#E7E9E9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_209_8601)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_209_8601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: -70,
    cy: -375,
    r: 400,
    fill: "#5D5D5D"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_209_8601)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 176,
    cy: 601,
    r: 400,
    fill: "#5D5D5D"
  })))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M136.743 73.2242C136.709 72.0453 135.724 70.786 134.258 70.5248C134.023 70.4846 133.876 70.4578 133.748 70.4511C133.266 70.431 60.9444 67.1488 59.1626 67.0685C57.7292 67.0015 56.8249 66.7469 56.0479 68.0062C55.6259 68.6828 55.5388 69.4799 55.5522 70.2435C55.5924 71.8912 55.6661 72.7821 55.6661 73.2376C55.6661 79.1589 53.3686 81.1349 49.8788 81.8182C46.9985 82.3808 43.9775 82.3875 43.9775 82.3875L51.3859 137.501C51.3859 137.501 126.099 148.795 127.305 148.828C128.082 148.848 129.669 148.835 130.426 148.56C132.355 147.85 133.668 146.638 134.405 145.466C135.671 143.463 136.481 141.54 136.917 139.41C137.419 136.939 137.687 134.32 137.647 131.808C137.647 131.801 136.743 73.2242 136.743 73.2242Z",
    fill: "url(#paint0_linear_209_8601)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.647 131.803C137.687 134.322 137.412 136.934 136.917 139.406C136.488 141.536 135.678 143.465 134.405 145.461C133.668 146.626 132.355 147.845 130.426 148.555C129.676 148.83 128.082 148.85 127.305 148.823C127.211 148.817 126.648 148.75 125.697 148.616C114.698 147.068 51.3859 137.503 51.3859 137.503L43.9775 82.3894C43.9775 82.3894 46.9985 82.3894 49.8788 81.8201C53.3686 81.1368 55.6661 79.1675 55.6661 73.2395C55.6661 72.784 55.5924 71.8932 55.5522 70.2454C55.5388 69.4818 55.6259 68.6847 56.0412 68.0081C56.8249 66.7488 57.7225 67.0101 59.1626 67.0704C60.9444 67.1507 133.266 70.4329 133.748 70.453C133.802 70.453 133.862 70.4597 133.923 70.4664C134.01 70.4798 134.117 70.4932 134.258 70.52C135.724 70.7879 136.702 72.0405 136.736 73.2194L137.647 131.803Z",
    fill: "url(#paint1_linear_209_8601)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M126.369 69.8367C128.379 64.2771 131.42 58.128 136.457 54.6382C137.475 53.9349 138.875 53.0507 139.759 52.3005C137.502 52.2 134.849 52.2469 132.585 52.2268C127.133 52.1732 104.332 51.9321 98.3834 51.8718C94.5252 51.8316 90.667 51.7914 86.8087 51.7512C82.3008 51.711 78.3488 56.3932 76.1048 59.8227C73.5729 63.6876 71.9653 68.1018 70.7797 72.5428C69.1721 78.5646 65.7291 108.144 65.2267 110.871C64.3359 115.693 61.8642 123.336 55.6816 122.948C58.16 123.129 104.754 126.819 108.384 127.081C112.617 127.382 115.357 124.207 117.025 120.697C119.075 116.397 120.91 97.2864 121.506 92.3431C122.096 87.3863 125.465 72.3419 126.369 69.8367Z",
    fill: "url(#paint2_linear_209_8601)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M126.369 69.8367C128.379 64.2771 131.42 58.128 136.457 54.6382C137.475 53.9349 138.875 53.0507 139.759 52.3005C137.502 52.2 134.849 52.2469 132.585 52.2268C127.133 52.1732 104.332 51.9321 98.3834 51.8718C94.5252 51.8316 90.667 51.7914 86.8087 51.7512C82.3008 51.711 78.3488 56.3932 76.1048 59.8227C73.5729 63.6876 71.9653 68.1018 70.7797 72.5428C69.1721 78.5646 65.7291 108.144 65.2267 110.871C64.3359 115.693 61.8642 123.336 55.6816 122.948C58.16 123.129 104.754 126.819 108.384 127.081C112.617 127.382 115.357 124.207 117.025 120.697C119.075 116.397 120.91 97.2864 121.506 92.3431C122.096 87.3863 125.465 72.3419 126.369 69.8367Z",
    fill: "url(#paint3_linear_209_8601)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M116.12 128.348C117.721 126.961 119.021 125.186 119.992 123.331C121.372 120.685 122.209 117.671 122.765 114.744C123.964 108.394 124.339 101.903 125.036 95.4926C125.404 92.0966 125.813 88.6938 126.369 85.3246C127.085 80.9372 128.03 76.5632 129.37 72.3231C130.743 67.9759 132.685 63.2536 135.88 59.9245C137.3 58.4509 138.901 57.3323 140.73 56.6758C141.922 56.2472 142.217 54.9477 141.855 53.8759C141.5 52.8109 140.395 52.0138 139.256 52.4224C137.233 53.1458 135.385 54.4453 133.703 56.1735C129.892 60.0853 127.447 65.4172 125.679 70.5146C124.111 75.0426 123.04 79.8119 122.269 84.5342C121.707 87.9905 121.278 91.4736 120.903 94.9568C120.374 99.8532 119.938 104.763 119.329 109.653C118.86 113.391 118.217 117.477 116.529 120.886C115.852 122.246 114.6 123.76 113.133 124.905L116.12 128.348Z",
    fill: "url(#paint4_linear_209_8601)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M118.545 59.0791C120.554 53.5195 123.595 47.3705 128.632 43.8806C129.651 43.1773 131.051 42.2931 131.935 41.5429C129.677 41.4424 127.025 41.4893 124.761 41.4692C119.308 41.4156 96.5073 41.1745 90.5592 41.1142C86.7077 41.0807 82.8428 41.0405 78.9845 41.0003C74.4766 40.9535 70.5245 45.6423 68.2806 49.0651C65.7486 52.9301 64.141 57.3443 62.9554 61.7852C61.3478 67.807 57.9049 97.3868 57.4025 100.113C56.5117 104.936 54.04 112.579 47.8574 112.19C50.3358 112.371 96.9293 116.062 100.56 116.323C104.793 116.624 107.533 113.449 109.201 109.939C111.25 105.639 113.086 86.5288 113.682 81.5855C114.271 76.6287 117.641 61.591 118.545 59.0791Z",
    fill: "url(#paint5_radial_209_8601)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.545 59.0791C120.554 53.5195 123.595 47.3705 128.632 43.8806C129.651 43.1773 131.051 42.2931 131.935 41.5429C129.677 41.4424 127.025 41.4893 124.761 41.4692C119.308 41.4156 96.5073 41.1745 90.5592 41.1142C86.7077 41.0807 82.8428 41.0405 78.9845 41.0003C74.4766 40.9535 70.5245 45.6423 68.2806 49.0651C65.7486 52.9301 64.141 57.3443 62.9554 61.7852C61.3478 67.807 57.9049 97.3868 57.4025 100.113C56.5117 104.936 54.04 112.579 47.8574 112.19C50.3358 112.371 96.9293 116.062 100.56 116.323C104.793 116.624 107.533 113.449 109.201 109.939C111.25 105.639 113.086 86.5288 113.682 81.5855C114.271 76.6287 117.641 61.591 118.545 59.0791Z",
    fill: "url(#paint6_linear_209_8601)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M108.317 117.576C109.911 116.189 111.204 114.421 112.175 112.572C113.555 109.926 114.392 106.912 114.948 103.985C116.147 97.6348 116.522 91.1441 117.219 84.7338C117.587 81.3378 117.996 77.935 118.552 74.5658C119.269 70.1784 120.213 65.8044 121.553 61.5643C122.926 57.2171 124.868 52.4948 128.063 49.1657C129.483 47.6921 131.084 46.5735 132.913 45.9171C134.105 45.4884 134.4 44.1889 134.038 43.1172C133.683 42.0521 132.578 41.255 131.439 41.6636C129.417 42.387 127.568 43.6865 125.886 45.4147C122.075 49.3265 119.63 54.6584 117.862 59.7558C116.295 64.2839 115.223 69.0531 114.452 73.7754C113.89 77.2317 113.461 80.7148 113.086 84.198C112.557 89.0944 112.121 94.0043 111.512 98.8941C111.043 102.632 110.4 106.718 108.712 110.127C108.056 111.453 106.85 112.914 105.437 114.046L108.317 117.576Z",
    fill: "url(#paint7_linear_209_8601)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M121.285 101.493L80.0966 99.3565C78.4756 99.2761 77.0421 98.3652 76.4058 97.0188L71.1811 85.9264C70.5448 84.5733 69.1113 83.669 67.4903 83.5887C67.4903 83.5887 43.9524 82.383 43.939 82.383C43.1553 82.3495 42.6797 83.0662 42.4118 83.6289C42.097 84.2786 41.9831 85.002 42.0032 85.712C42.0032 85.7187 42.0032 85.7187 42.0032 85.7254L43.1017 130.852C43.162 133.404 43.5907 135.976 44.6691 138.347C45.1447 139.392 45.7543 140.411 46.5648 141.281C47.4958 142.273 48.8355 143.123 50.3158 143.231C51.0526 143.284 51.7895 143.338 52.5263 143.391C54.5224 143.539 56.5185 143.679 58.5146 143.827C61.4484 144.041 64.389 144.255 67.3229 144.47C70.8797 144.731 74.4365 144.985 77.9866 145.247C81.8381 145.528 85.6964 145.809 89.5479 146.091C93.3793 146.372 97.2175 146.647 101.049 146.928C104.539 147.183 108.035 147.437 111.525 147.692C114.358 147.899 117.185 148.1 120.019 148.308C121.867 148.442 123.723 148.576 125.571 148.71C126.148 148.75 127.293 148.837 127.293 148.837L121.285 101.493Z",
    fill: "url(#paint8_linear_209_8601)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M127.186 148.817C127.186 148.817 126.121 148.737 125.585 148.703C123.736 148.569 121.887 148.435 120.032 148.301C117.199 148.094 114.365 147.886 111.538 147.685C108.049 147.43 104.552 147.176 101.062 146.921C97.2309 146.647 93.3927 146.365 89.5613 146.084C85.7098 145.803 81.8515 145.521 78 145.24C74.4432 144.979 70.8864 144.724 67.3296 144.463C64.3957 144.249 61.4551 144.034 58.5213 143.82C56.5252 143.673 54.5291 143.532 52.5263 143.385C51.7895 143.331 51.0526 143.277 50.3158 143.224C48.8355 143.117 47.4891 142.273 46.5648 141.281C45.7543 140.417 45.1447 139.399 44.6691 138.347C43.5907 135.976 43.162 133.397 43.1017 130.852L42.0032 85.7254V85.712C41.9831 85.0087 42.097 84.2853 42.4118 83.6289C42.6797 83.0662 43.1553 82.3495 43.939 82.383C43.9524 82.383 62.6206 83.3341 66.7066 83.5485C67.209 83.5753 67.4903 83.5887 67.4903 83.5887C69.1113 83.669 70.5448 84.58 71.1811 85.9264L76.4058 97.0121C77.0421 98.3585 78.4756 99.2694 80.0966 99.3498L80.197 99.3565L121.331 101.493L127.186 148.817Z",
    fill: "url(#paint9_linear_209_8601)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M137.65 131.803C137.69 134.322 137.416 136.934 136.92 139.406C136.491 141.536 135.681 143.465 134.408 145.461C133.671 146.627 132.358 147.846 130.429 148.556C129.679 148.831 128.085 148.851 127.308 148.824C127.214 148.817 126.752 148.851 125.854 148.516C125.372 148.335 124.849 147.94 124.287 147.424C122.626 145.883 121.782 143.8 121.239 141.75C120.757 139.942 120.496 138.013 120.496 136.157L119.712 104.916C119.698 103.959 119.712 101.38 121.333 101.494C123.001 101.614 126.109 102.331 129.19 99.9998C132.331 97.6152 132.593 85.8329 132.559 83.5488L132.405 73.9032C132.392 72.9319 132.579 70.5339 133.932 70.4736C134.019 70.487 134.127 70.5004 134.267 70.5272C135.734 70.7952 136.712 72.0477 136.746 73.2266L137.65 131.803Z",
    fill: "url(#paint10_linear_209_8601)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M137.65 131.803C137.69 134.322 137.416 136.934 136.92 139.406C136.491 141.536 135.681 143.465 134.408 145.461C133.671 146.627 132.358 147.846 130.429 148.556C129.679 148.831 128.085 148.851 127.308 148.824C127.214 148.817 126.752 148.851 125.854 148.516C125.372 148.335 124.849 147.94 124.287 147.424C122.626 145.883 121.782 143.8 121.239 141.75C120.757 139.942 120.496 138.013 120.496 136.157L119.712 104.916C119.698 103.959 119.712 101.38 121.333 101.494C123.001 101.614 126.109 102.331 129.19 99.9998C132.331 97.6152 132.593 85.8329 132.559 83.5488L132.405 73.9032C132.392 72.9319 132.579 70.5339 133.932 70.4736C134.019 70.487 134.127 70.5004 134.267 70.5272C135.734 70.7952 136.712 72.0477 136.746 73.2266L137.65 131.803Z",
    fill: "url(#paint11_radial_209_8601)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1468 99.2889C76.3382 99.2085 73.7728 98.4784 72.9288 96.69L66.7061 83.5479C67.2084 83.5746 67.4898 83.588 67.4898 83.588C69.1108 83.6684 70.5442 84.5794 71.1805 85.9258L76.4052 97.0115C77.0416 98.3578 78.475 99.2688 80.096 99.3492C80.096 99.3559 79.2721 99.3358 78.1468 99.2889Z",
    fill: "url(#paint12_linear_209_8601)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.867 60.9073L94.5383 60.5925C93.5738 60.5657 92.8972 59.8088 93.0178 58.9112C93.1384 58.0136 94.0226 57.3036 94.9804 57.3371L105.309 57.6519C106.274 57.6787 106.95 58.4356 106.83 59.3332C106.709 60.2308 105.832 60.9341 104.867 60.9073Z",
    fill: "#A2A8AA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.985 66.113L88.0481 65.4499C87.0835 65.4231 86.407 64.6662 86.5276 63.7686C86.6481 62.871 87.5323 62.161 88.4902 62.1945L110.427 62.8576C111.392 62.8844 112.068 63.6413 111.948 64.5389C111.827 65.4365 110.95 66.1398 109.985 66.113Z",
    fill: "#A2A8AA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M106.127 77.5718L87.7733 77.0159C87.0231 76.9958 86.4872 76.4063 86.581 75.6963C86.6747 74.993 87.3647 74.437 88.1216 74.4638L106.475 75.0198C107.225 75.0399 107.761 75.6293 107.667 76.3393C107.567 77.0427 106.884 77.5986 106.127 77.5718Z",
    fill: "#C7CDCF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.571 82.5367L87.2176 81.9807C86.4674 81.9606 85.9315 81.3712 86.0253 80.6612C86.1191 79.9578 86.809 79.4019 87.5659 79.4287L105.919 79.9846C106.67 80.0047 107.205 80.5942 107.112 81.3042C107.011 82.0075 106.321 82.5635 105.571 82.5367Z",
    fill: "#C7CDCF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M105.082 87.3941L86.7283 86.8381C85.9781 86.818 85.4423 86.2286 85.536 85.5186C85.6298 84.8153 86.3197 84.2593 87.0767 84.2861L105.43 84.842C106.18 84.8621 106.716 85.4516 106.622 86.1616C106.522 86.8649 105.832 87.4142 105.082 87.3941Z",
    fill: "#C7CDCF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M104.581 60.5919L94.2522 60.277C93.2876 60.2502 92.6111 59.4933 92.7317 58.5958C92.8522 57.6982 93.7364 56.9882 94.6943 57.0216L105.023 57.3365C105.988 57.3633 106.664 58.1202 106.544 59.0177C106.423 59.9153 105.546 60.6186 104.581 60.5919Z",
    fill: "url(#paint13_linear_209_8601)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.695 65.7908L87.7581 65.1276C86.7935 65.1008 86.117 64.3439 86.2375 63.4463C86.3581 62.5488 87.2423 61.8387 88.2001 61.8722L110.137 62.5354C111.102 62.5622 111.778 63.3191 111.658 64.2166C111.537 65.1142 110.66 65.8242 109.695 65.7908Z",
    fill: "url(#paint14_linear_209_8601)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M109.021 71.7204L87.0842 71.0573C86.1197 71.0305 85.4431 70.2736 85.5637 69.376C85.6843 68.4784 86.5685 67.7684 87.5263 67.8019L109.463 68.4651C110.428 68.4918 111.104 69.2488 110.984 70.1463C110.863 71.0439 109.986 71.7472 109.021 71.7204Z",
    fill: "#A2A8AA"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M108.738 71.404L86.801 70.7409C85.8365 70.7141 85.1599 69.9572 85.2805 69.0596C85.4011 68.162 86.2853 67.452 87.2431 67.4855L109.18 68.1486C110.145 68.1754 110.821 68.9324 110.701 69.8299C110.58 70.7275 109.696 71.4308 108.738 71.404Z",
    fill: "url(#paint15_linear_209_8601)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M105.785 77.19L87.4315 76.634C86.6813 76.6139 86.1454 76.0245 86.2392 75.3145C86.3329 74.6112 87.0229 74.0552 87.7798 74.082L106.133 74.6379C106.883 74.658 107.419 75.2475 107.325 75.9575C107.225 76.6608 106.535 77.2101 105.785 77.19Z",
    fill: "url(#paint16_linear_209_8601)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M105.223 82.1549L86.8699 81.5989C86.1197 81.5788 85.5839 80.9893 85.6776 80.2793C85.7714 79.576 86.4613 79.02 87.2183 79.0468L105.572 79.6028C106.322 79.6229 106.858 80.2123 106.764 80.9224C106.663 81.6257 105.98 82.1816 105.223 82.1549Z",
    fill: "url(#paint17_linear_209_8601)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.735 87.0113L86.3817 86.4553C85.6315 86.4352 85.0956 85.8458 85.1894 85.1358C85.2831 84.4324 85.9731 83.8765 86.73 83.9033L105.083 84.4592C105.834 84.4793 106.369 85.0688 106.276 85.7788C106.182 86.4821 105.492 87.0314 104.735 87.0113Z",
    fill: "url(#paint18_linear_209_8601)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M104.908 92.1802L86.5545 91.6243C85.8043 91.6042 85.2684 91.0147 85.3622 90.3047C85.456 89.6014 86.1459 89.0454 86.9028 89.0722L105.256 89.6282C106.006 89.6483 106.542 90.2377 106.449 90.9477C106.348 91.6511 105.665 92.2003 104.908 92.1802Z",
    fill: "#C7CDCF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M104.559 91.7994L86.2059 91.2434C85.4557 91.2233 84.9198 90.6339 85.0136 89.9239C85.1074 89.2205 85.7973 88.6646 86.5542 88.6914L104.908 89.2473C105.658 89.2674 106.194 89.8569 106.1 90.5669C106.006 91.2702 105.316 91.8195 104.559 91.7994Z",
    fill: "url(#paint19_linear_209_8601)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_209_8601",
    x: -620,
    y: -925,
    width: 1100,
    height: 1100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_209_8601"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_209_8601",
    x: -374,
    y: 51,
    width: 1100,
    height: 1100,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 75,
    result: "effect1_foregroundBlur_209_8601"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_209_8601",
    x1: 43.9766,
    y1: 107.919,
    x2: 137.649,
    y2: 107.919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A87F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0623754,
    stopColor: "#466BF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.127,
    stopColor: "#3453FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.161,
    stopColor: "#395BF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2902,
    stopColor: "#4B76F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4221,
    stopColor: "#5789F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5573,
    stopColor: "#5F94F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.701,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.807,
    stopColor: "#5F95F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8847,
    stopColor: "#5A8CF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9532,
    stopColor: "#527CF9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#496CFB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_209_8601",
    x1: 92.531,
    y1: 68.2025,
    x2: 91.5075,
    y2: 91.7316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0150645,
    stopColor: "#C8CCD1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2024,
    stopColor: "#919395"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_209_8601",
    x1: 91.6821,
    y1: 87.6223,
    x2: 123.56,
    y2: 89.6565,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6912,
    stopColor: "#729EB1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8431,
    stopColor: "#92BCCD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B7DFED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_209_8601",
    x1: 100.472,
    y1: 49.4678,
    x2: 94.9464,
    y2: 126.109,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D7DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9333,
    stopColor: "#E6E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    stopColor: "#DDDEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_209_8601",
    x1: 154.48,
    y1: 57.3077,
    x2: 98.6144,
    y2: 123.89,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0344497,
    stopColor: "#E6F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089574,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3014,
    stopColor: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7562,
    stopColor: "#9AA8AD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_209_8601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(-72.4604 62.4158) rotate(4.12317) scale(212.495 212.495)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6262,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6331,
    stopColor: "#C1E3EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6522,
    stopColor: "#D7ECF4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6732,
    stopColor: "#E7F3F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6971,
    stopColor: "#F0F7FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7302,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8171,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8246,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.847,
    stopColor: "#EAF4F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8833,
    stopColor: "#D2EAF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9152,
    stopColor: "#B7DFED"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9495,
    stopColor: "#B1DAE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.995,
    stopColor: "#A0CBDA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9EC9D8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_209_8601",
    x1: 92.6475,
    y1: 38.717,
    x2: 87.1231,
    y2: 115.351,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1.1e-7,
    stopColor: "#E6E9E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2142,
    stopColor: "#F3F8FB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8243,
    stopColor: "#D7DFE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9333,
    stopColor: "#E6E7E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9878,
    stopColor: "#DDDEDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_209_8601",
    x1: 146.611,
    y1: 46.548,
    x2: 90.7168,
    y2: 112.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F3FBFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0344497,
    stopColor: "#E6F3FC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.089574,
    stopColor: "#DADADA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1605,
    stopColor: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3014,
    stopColor: "#E1E2E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4518,
    stopColor: "#D7D7D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7562,
    stopColor: "#9AA8AD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_209_8601",
    x1: 41.9977,
    y1: 115.606,
    x2: 127.306,
    y2: 115.606,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0464793,
    stopColor: "#72ABF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0976302,
    stopColor: "#7FB8F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1447,
    stopColor: "#83BCFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3226,
    stopColor: "#6EA6F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.473,
    stopColor: "#6198F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6323,
    stopColor: "#5E90F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7511,
    stopColor: "#5A87F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_209_8601",
    x1: 87.4176,
    y1: 78.3425,
    x2: 82.2472,
    y2: 149.207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.101334,
    stopColor: "#BABBBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1283,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1284,
    stopColor: "#B1B1B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1591,
    stopColor: "#9A9DA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.216062,
    stopColor: "#94979C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317959,
    stopColor: "#8E9297"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.520277,
    stopColor: "#88898C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8167,
    stopColor: "#6A6B70"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9239,
    stopColor: "#696A6E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#545559"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_209_8601",
    x1: 116.47,
    y1: 109.844,
    x2: 138.723,
    y2: 109.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1477,
    stopColor: "#5A87F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5442,
    stopColor: "#496CFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6605,
    stopColor: "#4C71FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7957,
    stopColor: "#537FF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9397,
    stopColor: "#6096F5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9496,
    stopColor: "#6198F5"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_209_8601",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(123.712 71.1561) scale(77.7154 77.7154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0157711,
    stopColor: "#D2D4D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3954,
    stopColor: "#999EA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.655,
    stopColor: "#989BA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8736,
    stopColor: "#787A7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9882,
    stopColor: "#818181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9883,
    stopColor: "#7F8082"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_209_8601",
    x1: 76.5107,
    y1: 89.9814,
    x2: 70.39,
    y2: 92.8707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3099,
    stopColor: "#A1A1A4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8737,
    stopColor: "#797D8B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_209_8601",
    x1: 100.478,
    y1: 55.3923,
    x2: 100.299,
    y2: 61.2756,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_209_8601",
    x1: 100.492,
    y1: 60.084,
    x2: 100.375,
    y2: 66.5454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_209_8601",
    x1: 99.5349,
    y1: 65.6974,
    x2: 99.4182,
    y2: 72.1582,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_209_8601",
    x1: 98.0633,
    y1: 72.6637,
    x2: 97.9747,
    y2: 77.7883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_209_8601",
    x1: 97.5017,
    y1: 77.6284,
    x2: 97.4132,
    y2: 82.7536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_209_8601",
    x1: 97.0135,
    y1: 82.485,
    x2: 96.9249,
    y2: 87.6096,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_209_8601",
    x1: 96.8377,
    y1: 87.2731,
    x2: 96.7492,
    y2: 92.3977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADADAD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0547085,
    stopColor: "#B6B4B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1231,
    stopColor: "#CFCFCF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.195,
    stopColor: "#C1C1C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2755,
    stopColor: "#ACACAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.342213,
    stopColor: "#A59EAB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3745,
    stopColor: "#818085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.566,
    stopColor: "#4C4A4E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7594,
    stopColor: "#5E5D60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8151,
    stopColor: "#545257"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8726,
    stopColor: "#535256"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9307,
    stopColor: "#4D4C50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9891,
    stopColor: "#434245"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E3D40"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_209_8601"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWlFavicon192X192);
export default __webpack_public_path__ + "static/media/WLFavicon_192x192.73ee5e0affe19e975d1d4a5e80b817ec.svg";
export { ForwardRef as ReactComponent };